export default __webpack_public_path__ + "static/media/Ahukhana.7acbc154.jpg";